import { Tooltip, TooltipContent, TooltipTrigger } from "@src/lib/ui/Tooltip";
import { FC } from "react";

type Props = {
  children: React.ReactElement;
  hasPermission?: boolean;
  tooltipSide?: "top" | "right" | "bottom" | "left";
  tooltipAlign?: "start" | "center" | "end";
  caretPosition?: string;
  disabledOpacity?: number;
};

const NoPermissionsTooltipWrapper: FC<Props> = ({
  children,
  hasPermission = false,
  tooltipSide = "right",
  tooltipAlign = "center",
  disabledOpacity = 0.6,
}) => {
  if (hasPermission) {
    return <>{children}</>;
  }
  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger
        asChild
        style={{
          cursor: "not-allowed",
          opacity: disabledOpacity,
        }}
        onClickCapture={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        {children}
      </TooltipTrigger>
      <TooltipContent align={tooltipAlign} side={tooltipSide} sideOffset={4}>
        You do not have permission
      </TooltipContent>
    </Tooltip>
  );
};

export default NoPermissionsTooltipWrapper;
